import { IsAuthRequest, LoginRequest, LogoutRequest, MagicLoginRequest, CurrentUserRequest, SOCKET_CONNECTION, ResetPasswordRequest, SetPasswordRequest } from 'client/features/session/actions'

const initialState = {
    user: {},
    loaded: false,
    loggingIn: false,
    error: null,
    resetPasswordSubmited: false
}

const initializeState = () => Object.assign({}, initialState)

export default function session(state = initializeState(), action = {}) {
    switch (action.type) {

    case IsAuthRequest.get.TYPES.SUCCESS:
        return { ...state, loggingIn: true, user: action.payload.user, loaded: true, error: null }

    case IsAuthRequest.get.TYPES.FAILURE:
        return { ...state, loggingIn: false, user: null, loaded: true, error: null }

    case LoginRequest.post.TYPES.SUCCESS:
        return { ...state, loggingIn: true, user: action.payload.user, loaded: true, error: null }

    case LoginRequest.post.TYPES.FAILURE:
        return { ...state, loggingIn: false, user: null, loaded: true, error: action.payload.error }

    case MagicLoginRequest.post.TYPES.FAILURE:
        return { ...state, loggingIn: false, user: null, loaded: true, error: action.payload.error }

    case MagicLoginRequest.post.TYPES.SUCCESS:
        return { ...state, loggingIn: false, user: null, loaded: true, error: null }

    case LogoutRequest.get.TYPES.SUCCESS:
        return { ...state, loggingIn: false, user: null, loaded: true, error: null }

    case CurrentUserRequest.put.TYPES.SUCCESS:
        return { ...state, user: action.payload.user }

    case ResetPasswordRequest.post.TYPES.REQUEST:
        return { ...state, resetPasswordSubmited: false, resetPasswordProgress: true, resetPasswordFailure: false }

    case ResetPasswordRequest.post.TYPES.FAILURE:
        return { ...state, resetPasswordFailure: true, resetPasswordProgress: false }

    case ResetPasswordRequest.post.TYPES.SUCCESS:
        return { ...state, resetPasswordSubmited: true, resetPasswordProgress: false }

    case SOCKET_CONNECTION:
        return { ...state, socket: { id: action.payload.id } }

    case SetPasswordRequest.post.TYPES.REQUEST:
        return { ...state, setPasswordSubmited: false, setPasswordProgress: true, setPasswordFailure: false }

    case SetPasswordRequest.post.TYPES.FAILURE:
        return { ...state, setPasswordFailure: true, setPasswordProgress: false }

    case SetPasswordRequest.post.TYPES.SUCCESS:
        return { ...state, setPasswordSubmited: true, setPasswordProgress: false }

    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/session/reducers.js